<app-enfaf-modal
  (onClose)="confirmCloseModal()"
  buttonCancelText="Cancelar"
  buttonConfirmText="Guardar"
  (onConfirm)="saveCourse()"
  [isLoading]="isSavingCourse"
  [disableConfirmButton]="!formModified || isSavingCourse || isLoadingPredecessorPrefill"
  svgIcon="film"
  [title]="editMode ? 'Editar curso' : isCreatingEdition ? ('COURSE.EDITION.NEW_EDITION_TITLE' | translate) : 'Nuevo curso'"
  [ngStyleTitle]="{ 'padding-top': '8px' }"
  [ngStyleContent]="{ 'padding-bottom': '0' }"
>
  @if (isLoadingCourse) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  }

  @if (!isLoadingCourse && courseForm) {
    <mat-accordion class="custom-accordion" [multi]="true">
      <!-- COURSE INFO -->

      <app-enfaf-expansion-panel-light title="Información del curso" [isExpanded]="true">
        <div class="info-course">
          <div class="info-course-col-img-dragger">
            <app-enfaf-img-dragger
              [urlImage]="course?.courseImageUrl"
              (onImageUpload)="uploadImage($event)"
              (onImageDelete)="deleteImage()"
            ></app-enfaf-img-dragger>
          </div>
          <form class="info-course-col-form" [formGroup]="courseForm">
            <app-course-edition-fields
              [isSuccessorControl]="isSuccessorFC"
              [editionNumberControl]="editionNumberFC"
              [validFromControl]="validFromFC"
              [validUntilControl]="validUntilFC"
              [showEditionControls]="showEditionControls"
              [rootName]="editionRootName"
              [editMode]="editMode"
              [isLoadingPrefill]="isLoadingPredecessorPrefill"
            />

            @if (isMasterRoot) {
              <!-- ENF-2372 v2: a Máster root names the whole Máster; its course name is «{masterName} - 1ª Edición». -->
              <enfaf-input
                class="course-name-field"
                data-testid="masterName"
                color="light"
                [appFieldErrorA11y]="!!masterNameErrorLabel && (masterNameFC.touched || masterNameFC.dirty)"
                [control]="masterNameFC"
                [label]="'COURSE.EDITION.MASTER_NAME_LABEL' | translate"
                name="masterName"
                [placeholder]="'COURSE.EDITION.MASTER_NAME_LABEL' | translate"
                autocomplete="off"
                [readonly]="!canEditMasterName"
                [maxlength]="masterNameMaxLengthAttr"
                [errorLabel]="masterNameErrorLabel"
                [description]="masterNameHint"
              ></enfaf-input>
            } @else {
              <enfaf-input
                class="course-name-field"
                color="light"
                [appFieldErrorA11y]="!!nameErrorLabel && (nameFC.touched || nameFC.dirty)"
                [control]="courseForm.controls.name"
                label="Nombre del curso"
                name="name"
                placeholder="Nombre del curso"
                autocomplete="off"
                [readonly]="isEditionNameLocked"
                [maxlength]="nameMaxLengthAttr"
                [errorLabel]="nameErrorLabel"
                [description]="isEditionNameLocked ? ('COURSE.EDITION.NAME_GENERATED_HINT' | translate) : ''"
              ></enfaf-input>
            }

            @if (editionNameTooLong) {
              <span class="edition-warning" role="alert" data-testid="editionNameTooLong">{{
                'COURSE.EDITION.NAME_TOO_LONG_WARNING' | translate: { max: courseNameMaxLength }
              }}</span>
            }

            <enfaf-select-light
              label="Modalidad"
              name="modality"
              [control]="courseForm.controls.modality"
              [options]="courseModalityOptions"
              [hint]="modalityLocked ? ('COURSE.EDITION.MODALITY_LOCKED' | translate) : ''"
            >
            </enfaf-select-light>

            <!-- ENF-2372: the validity of a Máster goes right under its modality. -->
            <app-course-edition-fields
              [isSuccessorControl]="isSuccessorFC"
              [editionNumberControl]="editionNumberFC"
              [validFromControl]="validFromFC"
              [validUntilControl]="validUntilFC"
              [showValidity]="showEditionValidity"
              [editMode]="editMode"
            />

            @if (isFlash) {
              <enfaf-input
                color="light"
                [control]="courseForm.controls.duration"
                label="Disponibilidad del curso (días)"
                name="duration"
                placeholder="Disponibilidad del curso (días)"
                autocomplete="off"
                type="number"
                description="Días en los que los alumnos podrán completar el curso tras su registro."
              ></enfaf-input>
            }

            @if (isFP) {
              <enfaf-input
                color="light"
                [control]="courseForm.controls.yearsCount"
                label="Años de duración del Curso de Formación Profesional"
                name="yearsCount"
                placeholder="Años de duración del Curso de Formación Profesional"
                autocomplete="off"
                type="number"
                (keydown)="blockNonNumericKey($event)"
              ></enfaf-input>
            }

            <enfaf-input
              color="light"
              [control]="courseForm.controls.accreditationCenter"
              label="Entidad acreditadora"
              name="accreditationCenter"
              placeholder="Entidad acreditadora"
              autocomplete="off"
              type="text"
            ></enfaf-input>

            <enfaf-input
              color="light"
              [control]="courseForm.controls.socialMediaRedirectUrl"
              label="URL redirección redes sociales"
              name="socialMediaRedirectUrl"
              placeholder="URL redirección redes sociales"
              autocomplete="off"
              type="url"
            ></enfaf-input>

            <enfaf-input
              color="light"
              [control]="courseForm.controls.landingUrl"
              label="Landing URL (chatbot)"
              name="landingUrl"
              placeholder="https://enfaf.com/mi-curso"
              autocomplete="off"
              type="url"
            ></enfaf-input>

            <div class="chekbox-group">
              <app-enfaf-checkbox color="light" [control]="courseForm.controls.generateEnrollmentOrder"
                >Generar orden de matrícula</app-enfaf-checkbox
              >
              <app-enfaf-icon
                matTooltip="Marca esta casilla si quieres que se genere una orden de matrícula para todos los alumnos que se inscriban a este curso"
                matTooltipClass="chekbox-group-tooltip"
                matTooltipPosition="above"
                svgIconName="info-dark"
                iconSize="24px"
              ></app-enfaf-icon>
            </div>

            <div class="chekbox-group">
              <app-enfaf-checkbox color="light" [control]="courseForm.controls.requiresTfm">Se requiere entrega de TFM</app-enfaf-checkbox>
              <app-enfaf-icon
                matTooltip="Marca esta casilla si el curso requiere que los alumnos entreguen un Trabajo Fin de Máster"
                matTooltipClass="chekbox-group-tooltip"
                matTooltipPosition="above"
                svgIconName="info-dark"
                iconSize="24px"
              ></app-enfaf-icon>
            </div>

            <div class="chekbox-group">
              <app-enfaf-checkbox color="light" [control]="courseForm.controls.generateAutoevaluation"
                >Incluir la autoevaluación generada por IA</app-enfaf-checkbox
              >
              <app-enfaf-icon
                matTooltip="Marca esta casilla si quieres que se generen automáticamente preguntas de autoevaluación para las clases de este curso"
                matTooltipClass="chekbox-group-tooltip"
                matTooltipPosition="above"
                svgIconName="info-dark"
                iconSize="24px"
              ></app-enfaf-icon>
            </div>
          </form>
        </div>
      </app-enfaf-expansion-panel-light>

      <div class="expansion-separator"></div>

      <!-- COURSE TEACHERS -->
      <app-enfaf-expansion-panel-light title="Profesores y directores de contenido" [isExpanded]="true">
        <div class="course-staf">
          <div class="course-teachers">
            <div class="teachers-selector">
              <enfaf-multi-autocomplete-light
                #teachersAutocomplete
                [label]="'Asignar profesores/tutores'"
                [placeholder]="'Buscar profesores/tutores...'"
                [fetchData]="fetchTeachers"
                [selectedOptions]="selectedTeachersAndTutors"
                (selectedChanged)="onTeachersSelectionChanged($event)"
              >
              </enfaf-multi-autocomplete-light>
            </div>
            @if (selectedTeachersAndTutors.length > 0) {
              <div class="selected-teachers-container">
                <div class="selected-teachers-list">
                  <div class="selected-teachers-title">Profesores/tutores seleccionados:</div>
                  <div class="selected-teachers-container">
                    @for (teacher of selectedTeachersAndTutors; track teacher) {
                      <div class="teacher-row">
                        <div class="teacher-content">
                          <div class="teacher-info">
                            <div class="teacher-name">{{ teacher.title }}</div>
                            <div class="teacher-email">{{ teacher.subtitle }}</div>
                          </div>
                        </div>
                        <div class="teacher-actions">
                          <app-enfaf-icon
                            [svgIconName]="'trash-red'"
                            [iconSize]="'21px'"
                            [iconStyle]="{ color: '#E03131' }"
                            [isButton]="true"
                            (onClick)="removeTeacher(teacher)"
                            class="remove-icon"
                          >
                          </app-enfaf-icon>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="course-teachers">
            <div class="teachers-selector">
              <enfaf-multi-autocomplete-light
                #contentDirectorAutocomplete
                [label]="'Asignar directores de contenido'"
                [placeholder]="'Buscar directores de contenido...'"
                [fetchData]="fetchContentDirectors"
                [selectedOptions]="selectedContentDirectors"
                (selectedChanged)="onContentDirectorsSelectionChanged($event)"
              >
              </enfaf-multi-autocomplete-light>
            </div>
            @if (selectedContentDirectors.length > 0) {
              <div class="selected-teachers-container">
                <div class="selected-teachers-list">
                  <div class="selected-teachers-title">Directores de contenido seleccionados:</div>
                  <div class="selected-teachers-container">
                    @for (contentDirector of selectedContentDirectors; track contentDirector) {
                      <div class="teacher-row">
                        <div class="teacher-content">
                          <div class="teacher-info">
                            <div class="teacher-name">{{ contentDirector.title }}</div>
                            <div class="teacher-email">{{ contentDirector.subtitle }}</div>
                          </div>
                        </div>
                        <div class="teacher-actions">
                          <app-enfaf-icon
                            [svgIconName]="'trash-red'"
                            [iconSize]="'21px'"
                            [iconStyle]="{ color: '#E03131' }"
                            [isButton]="true"
                            (onClick)="removeContentDirector(contentDirector)"
                            class="remove-icon"
                          >
                          </app-enfaf-icon>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </app-enfaf-expansion-panel-light>

      <div class="expansion-separator"></div>

      <!-- COURSE DESCRIPTION -->
      <app-enfaf-expansion-panel-light title="Descripción del curso" [isExpanded]="true">
        <form class="course-description" [formGroup]="courseForm">
          <enfaf-input
            color="light"
            [control]="courseForm.controls.shortDescription"
            label="Descripción corta"
            name="shortDescription"
            placeholder="Descripción corta"
            autocomplete="off"
          ></enfaf-input>

          <app-enfaf-textarea-light
            label="Descripción detallada"
            placeholder="Descripción detallada"
            [rows]="7"
            [control]="courseForm.controls.description"
            autocomplete="off"
          ></app-enfaf-textarea-light>
        </form>
      </app-enfaf-expansion-panel-light>

      <div class="expansion-separator"></div>

      <!-- DOCUMENTATION -->

      <app-enfaf-expansion-panel-light title="Documentación" [isExpanded]="true">
        <form class="course-documentation" [formGroup]="courseForm">
          @if (!isFlash) {
            <div class="chekbox-group course-documentation__requirement">
              <app-enfaf-switch-dark color="light" [control]="courseForm.controls.requiresDni" label="Requiere aportar DNI" />
            </div>

            <div class="chekbox-group course-documentation__requirement">
              <app-enfaf-switch-dark color="light" [control]="courseForm.controls.requiresDegree" label="Requiere aportar Titulación" />
            </div>
          }

          @if (showDegreeRequirements) {
            <div class="course-documentation__equivalents">
              <enfaf-select-light
                label="Máster equivalente"
                name="equivalentMasterId"
                [control]="courseForm.controls.equivalentMasterId"
                [options]="equivalentMasterOptions"
              >
              </enfaf-select-light>

              <enfaf-select-light
                label="Curso equivalente"
                name="equivalentCourseId"
                [control]="courseForm.controls.equivalentCourseId"
                [options]="equivalentCourseOptions"
              >
              </enfaf-select-light>
            </div>

            @if (requiresDegreeMissingEquivalents) {
              <span class="competencies-error"
                >Completa "Máster equivalente" y "Curso equivalente" para poder generar correctamente el Excel de matriculaciones.</span
              >
            }
          }

          <div class="course-documentation__divider"></div>

          <enfaf-select-light
            label="Requiere documentos"
            name="requiresDocuments"
            [control]="courseForm.controls.requiresDocuments"
            [options]="requieredDocumentsOptions"
          >
          </enfaf-select-light>

          <app-enfaf-textarea-light
            label="Documentos requeridos"
            placeholder="Documentos requeridos"
            [rows]="4"
            [control]="courseForm.controls.requiredDocuments"
            autocomplete="off"
          ></app-enfaf-textarea-light>
        </form>
      </app-enfaf-expansion-panel-light>

      <div class="expansion-separator"></div>

      <!-- DIPLOMAS -->

      <app-enfaf-expansion-panel-light title="Diplomas" [isExpanded]="true">
        <form class="course-diplomas" [formGroup]="courseForm">
          @if (!isFlash) {
            <div class="chekbox-group">
              <app-enfaf-checkbox color="light" [control]="courseForm.controls.sendDiploma">¿Enviar diploma al finaliza el curso?</app-enfaf-checkbox>
            </div>
          }

          <div class="chekbox-group">
            <app-enfaf-checkbox color="light" [control]="courseForm.controls.attachCompetencies"
              >Adjuntar competencias en el diploma</app-enfaf-checkbox
            >
          </div>

          @if (competenciesError) {
            <span class="competencies-error">{{ competenciesError }}</span>
          }

          <enfaf-pdf-upload
            [title]="'Competencias del curso (PDF)'"
            [uploadText]="'Subir PDF de competencias'"
            [initialFile]="competenciesInitialFile"
            [maxFileSize]="competenciesMaxFileSize"
            (fileSelected)="onCompetenciesFileSelected($event)"
            (fileRemoved)="onCompetenciesFileRemoved()"
          ></enfaf-pdf-upload>
        </form>
      </app-enfaf-expansion-panel-light>

      <div class="expansion-separator"></div>

      <!-- PROMOTIONS -->

      <app-enfaf-expansion-panel-light title="Promociones" [isExpanded]="true">
        <form class="course-promotions" [formGroup]="courseForm">
          <app-enfaf-textarea-light
            label="Contenido"
            placeholder="Contenido"
            [rows]="7"
            [control]="courseForm.controls.promotionContent"
            autocomplete="off"
          ></app-enfaf-textarea-light>

          <div class="promotion-switches">
            <span class="promotion-switch-row">
              <app-enfaf-switch-dark color="light" [control]="courseForm.controls.showPromotionContent" />
              <span>Mostrar el bloque promocional</span>
            </span>

            <span class="promotion-switch-row">
              <app-enfaf-switch-dark color="light" [control]="courseForm.controls.showPromotionComments" />
              <span>Mostrar comentarios detrás del bloque promocional</span>
            </span>
          </div>
        </form>
      </app-enfaf-expansion-panel-light>

      <div class="expansion-separator"></div>

      <!-- COURSE INTEGRATIONS -->

      <app-enfaf-expansion-panel-light title="Integraciones" [isExpanded]="true">
        <form class="course-integrations" [formGroup]="courseForm">
          <div class="grid-2-full">
            <enfaf-input
              color="light"
              [control]="courseForm.controls.discord"
              label="Link de invitación de Discord"
              name="discord"
              placeholder="Link de invitación de Discord"
              autocomplete="off"
            ></enfaf-input>

            <enfaf-input
              color="light"
              [control]="courseForm.controls.whatsapp"
              label="Link de comunidad de WhatsApp"
              name="whatsapp"
              placeholder="Link de comunidad de WhatsApp"
              autocomplete="off"
            ></enfaf-input>
          </div>
          <div class="grid-4-full">
            <enfaf-input
              color="light"
              [control]="courseForm.controls.activeCampaignTagId"
              label="ID de etiqueta de Active Campaign"
              name="activeCampaignTagId"
              placeholder="ID de etiqueta de Active Campaign"
              autocomplete="off"
            ></enfaf-input>

            <enfaf-input
              color="light"
              [control]="courseForm.controls.activeCampaignListId"
              label="ID de lista de Active Campaign"
              name="activeCampaignListId"
              placeholder="ID de lista de Active Campaign"
              autocomplete="off"
            ></enfaf-input>

            <enfaf-input
              class="grid-4-full__span-2"
              color="light"
              [control]="courseForm.controls.universaeEndpoint"
              label="Endpoint Universae"
              name="universaeEndpoint"
              placeholder="Endpoint Universae"
              autocomplete="off"
            ></enfaf-input>
          </div>
        </form>
      </app-enfaf-expansion-panel-light>

      <!-- COURSE WHATSAPP MESSAGES -->
      <!-- Solo visible para God: el resto de roles no carga ni envía mensajes ni pipeline -->
      @if (isGod) {
        <div class="expansion-separator"></div>

        <app-enfaf-expansion-panel-light title="Mensajes Whatsapp" [isExpanded]="true">
          <form class="course-messages" [formGroup]="courseForm">
            <!-- ENF-2372 (C-6): an edition without messages of its own uses the ones of its root (1st edition). A new
                 edition always does: its switch and messages are hidden and not sent. -->
            @if (isCreatingEdition) {
              <p class="course-messages__note" data-testid="messagesInheritedNew">{{ 'COURSE.EDITION.MESSAGES_INHERITED_NEW' | translate }}</p>
            } @else if (inheritsRootMessages) {
              <p class="course-messages__note" data-testid="messagesInheritedEdit">{{ 'COURSE.EDITION.MESSAGES_INHERITED_EDIT' | translate }}</p>
            }

            @if (kommoEnabled) {
              <div class="course-messages__pipeline-row">
                <enfaf-input
                  color="light"
                  [control]="courseForm.controls.pipelineId"
                  label="ID de Pipeline (Kommo CRM)"
                  name="pipelineId"
                  placeholder="Ej: 12345"
                  autocomplete="off"
                  type="text"
                  [errorLabel]="pipelineErrorLabel"
                  [pending]="courseForm.controls.pipelineId.status === 'PENDING'"
                  [valid]="courseForm.controls.pipelineId.valid && !!courseForm.controls.pipelineId.value"
                ></enfaf-input>
                @if (!isCreatingEdition) {
                  <span class="course-messages__switch">
                    <app-enfaf-switch-dark color="light" [control]="courseForm.controls.autoMessagesEnabled" />
                    <span>Activar mensajes automáticos</span>
                  </span>
                }
              </div>
            } @else if (!isCreatingEdition) {
              <span class="course-messages__switch">
                <app-enfaf-switch-dark color="light" [control]="courseForm.controls.autoMessagesEnabled" />
                <span>Activar mensajes automáticos</span>
              </span>
            }

            @if (!isCreatingEdition && autoMessagesEnabled && courseMessagesControls.length > 0) {
              <div class="course-messages__list">
                <mat-accordion class="custom-course-message-accordion" [multi]="true">
                  @for (courseMessageFG of courseMessagesControls; track $index) {
                    @let message = getMessage(courseMessageFG.get('messageId')?.value);
                    <app-enfaf-expansion-panel-light
                      [isExpanded]="false"
                      class="custom-course-message-expansion"
                      [formGroup]="courseMessageFG"
                      (onOpened)="handleCourseMessageOpened(message.messageId)"
                    >
                      <span title class="custom-course-message-expansion__header">
                        <span>{{ message.title }}</span>
                        <app-enfaf-switch-dark color="light" [control]="courseMessageFG.controls.active" [disabled]="!message.kommoBotId" />
                      </span>
                      <div class="custom-course-message-expansion__content">
                        <fieldset class="custom-course-message-expansion__content-template">
                          <legend>Bot de Kommo</legend>
                          @if (message.kommoBotId) {
                            Bot ID: {{ message.kommoBotId }}
                          } @else {
                            Sin bot configurado
                          }
                        </fieldset>
                      </div>
                      @if (isSendConditionFlashOrInactivity(message)) {
                        <div class="custom-course-message-expansion__offset-wrapper">
                          <enfaf-input
                            class="offset-input"
                            color="light"
                            [label]="getMessageConditionOffsetLabel(message)"
                            [control]="courseMessageFG.controls.offset"
                            name="offset"
                            autocomplete="off"
                            type="number"
                            errorLabel="Requerido"
                            [showNumberSpinners]="true"
                          />
                        </div>
                      }
                    </app-enfaf-expansion-panel-light>
                  }
                </mat-accordion>
              </div>
            }
          </form>
        </app-enfaf-expansion-panel-light>

        <div class="expansion-separator"></div>

        <app-enfaf-expansion-panel-light title="Embajadores" [isExpanded]="true">
          <form class="course-ambassadors" [formGroup]="courseForm">
            <span class="course-ambassadors__switch">
              <app-enfaf-switch-dark color="light" [control]="courseForm.controls.isAmbassadorProgramEnabled" />
              <span>Activar programa de embajadores</span>
            </span>
            @if (isAssembadorProgramEnabled) {
              <div class="course-ambassadors-config">
                <div>
                  <enfaf-select-light
                    label="Tipo de comisión"
                    name="ambassadorCommissionType"
                    [control]="courseForm.controls.ambassadorCommissionType"
                    [options]="ambassadorCommissionTypeOptions"
                  >
                  </enfaf-select-light>
                </div>

                <div>
                  <enfaf-input
                    color="light"
                    [control]="courseForm.controls.ambassadorCommissionValue"
                    label="Valor de la comisión"
                    name="ambassadorCommissionValue"
                    placeholder="Valor de la comisión"
                    autocomplete="off"
                    type="number"
                    [iconSuffix]="assambladorCommissionIcon"
                    [errorLabel]="ambassadorCommissionValueError"
                  ></enfaf-input>
                </div>
              </div>
            }
          </form>
        </app-enfaf-expansion-panel-light>
      }
    </mat-accordion>
  }
</app-enfaf-modal>
